<template>
  <div id="page-event">
  <div class="main">
    <header class="header">
      <span
          class="tabItem tabItem-selected"
      >重点事件</span>
    </header>
    <div style="display: block">
      <div class="div-select">
        <Select class="job-select">
          <Option v-for="item in jobNameList" :value="item.id" :key="item.id" @click.native="getEventList(item.id)">{{item.name}}</Option>
        </Select>
        <DatePicker
            type="daterange"
            @on-ok="confirmDatePicker"
            v-model="dateRange"
            :start-date="datePickerStartDate"
            placement="bottom-end"
            placeholder="请选择日期范围"
            style="width: 200px"
            confirm
            class="datePicker"
            split-panels
        ></DatePicker>
      </div>
      <div class="tab-content">
        <Table border :columns="columns" :data="eventList">
          <template #action="{ row, index }" v-if="this.enable_report">
            <router-link :to="{ path: '/eventReport', query: { id: row.id } }" tag="button" class="ivu-btn ivu-btn-info ivu-btn-small">查看报告</router-link>
          </template>
        </Table>
      </div>

      <div class="page-wrapper">
        <Page
            :total="event_total"
            :current="currentPage"
            @on-change="changePage"
            show-total
        />
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      enable_report: false,
      jobNameList: [],
      dateRange: [],
      datePickerStartDate: new Date(),
      eventList: [],
      event_total: 0,
      currentPage: 1,
      queryData: {
        jobId: "",
        pageNum: 1,
        pageSize: 10
      },columns:[
        {
          title:"所属任务",
          key:"jobName"
        },
        {
          title:"日期",
          width: 110,
          key:"timeDur",
          align: 'center'
        },
        {
          title:"事件",
          key:"eventName"
        },
        {
          title:"地点",
          key:"address"
        },
        {
          title:"人数预测",
          key:"peopleNum",
          width: 110,
          align: 'center'
        },
        {
          title:"描述",
          key:"detail",
          ellipsis: true,
          tooltip: true,
          tooltipTheme:"light",
          tooltipMaxWidth:500
        },
        {
          title:"报告",
          slot:"action",
          width: 110,
          align: 'center'
        },
      ]
    }
  },
  methods: {
    getAuthorities() {
      let authorites = this.getLocalStorage("authorities").split(",");
      this.enable_report = authorites.includes("event_report");
    },
    confirmDatePicker() {
      // let startTime = this.dateRange[0].getTime();
      // let endTime = this.dateRange[1].getTime();
      this.getEventList();
    },

    getEventList(id) {
      if (id) {
        this.queryData.jobId = id
      }
      this.$ajax({
        method: "get",
        url: "./highlightEvent/getList",
        params: {
          pageNum: this.queryData.pageNum,
          pageSize: this.queryData.pageSize,
          jobId: this.queryData.jobId,
          startTime: this.dateRange[0],
          endTime: this.dateRange[1]
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.eventList = res.data.data.data;
            this.event_total = res.data.data.total;
          }
        }
      })
          .catch(err => {
            this.$Message.error(err);
            console.log(err);
          })
    },

    changePage(page) {
      this.queryData.pageNum = page;
      this.getEventList();
    },

    getJobNameList() {
      this.$ajax({
        method: "get",
        url: "./focusOn/getAllJobsMsg"
      })
          .then(res => {
            if (res.data.success) {
              if (res.data.data) {
                this.jobNameList = []
                this.jobNameList = res.data.data;
              }
            }
          })
    }
  },
  created() {
    this.getAuthorities();
    this.getEventList();
    this.getJobNameList();
  }
}
</script>

<style lang="less">
#page-event {
  .main {
    width: 1160px;
    margin: 0 auto;
    margin-top: 20px;
    background-color: #fff;
    box-sizing: border-box;
    min-height: 1040px;
    padding: 0 80px;
    box-shadow: 0 0 16px 0 #f3f4f7;
    .header {
      height: 80px;
      box-sizing: border-box;
      padding-top: 20px;
      border-bottom: 1px solid #efeff4;
      .tabItem {
        float: left;
        height: 60px;
        line-height: 60px;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #333333;
        margin-right: 75px;
        cursor: pointer;
      }
      .tabItem-selected {
        border-bottom: 3px solid #415af6;
      }
    }
  }
  .div-select {
    display: block;
    padding: 10px 0;
    text-align: left;
    .job-select {
      width: 200px;
      margin-right: 10px;
      display: inline-block;
      text-align: center;
    }
    .datePicker {
      width: 200px;
      display: inline-block;
    }
  }
}


.page-wrapper {
  margin-top: 40px;
}

.event-title span{
  width: 15%;
  margin-left: 20px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  line-height: 14px;
}

.event-info span {
  width: 15%;
  margin-left: 20px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  line-height: 14px;
}


</style>
